export const TYPE_OPTS = [
  {
    label: 'default',
    value: 'default',
  },
  {
    label: 'number',
    value: 'number',
  },
  {
    label: 'icon',
    value: 'icon',
  },
];

export const dispatchLeading = {
  default: () => <span>•</span>,
  number: ({ index } = {}) => <span>{index + 1}.</span>,
  icon: ({ icon }) =>
    icon || (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4ZM10.9657 6.96569C11.2781 6.65327 11.2781 6.14673 10.9657 5.83431C10.6533 5.5219 10.1467 5.5219 9.83431 5.83431L7.2 8.46863L6.16568 7.43431C5.85326 7.12189 5.34673 7.12189 5.03431 7.43431C4.72189 7.74673 4.72189 8.25327 5.03431 8.56569L6.63431 10.1657C6.94673 10.4781 7.45326 10.4781 7.76568 10.1657L10.9657 6.96569Z"
          fill="#0B9C66"
        />
      </svg>
    ),
};
